import React from 'react';
import HlsPlayer from '../HlsPlayer';
import { useLocation } from 'react-router-dom';


const AntMediaPlayer = () => {
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const base = process.env.REACT_APP_EMBEDDED_PROXY || '/proxy/playlist.m3u8';

  return (
    <div>
      <HlsPlayer streamUrl={`${base}/${id}`} />
    </div>
    
  );
};

export default AntMediaPlayer;
